 <div class="loading-wrapper" *ngIf="isLoadingdb">
  <div class="top-bar">
    <!-- <button class="back-btn">←</button>
    <span>Refreshing Media Contents</span> -->
  </div>

  <div class="status-container">
    <div class="status-box" *ngFor="let item of loadingItems">
      <div class="label">{{ item.label }}</div>
      <div
        class="status"
        [ngClass]="{ 'complete': item.loaded, 'downloading': !item.loaded }"
      >
        {{ item.loaded ? 'Complete' : 'Downloading...' }}
      </div>
    </div>
  </div>

  <div class="spinner"></div>
  <div class="bottom-bar">PLEASE WAIT...</div>
</div>

<div class="container-fluid auth-background">
    <div class="row">
      <div class="col-md-12 mt-3">
        <div class="header-w3l">
          <div class="logo ml-2">
            <!-- <img class="img-fluid" src="/assets/images/purple-web-player2.png" width="500" alt=""> -->
            <h3 class="mt-5">
              <a href="#">{{ "COMMON.TITLE" | translate }}</a>
            </h3>
          </div>
        </div>
        <div class="add-profile">
            <h2 class="d-flex justify-content-center align-items-center">Choose your Profile</h2>
        </div>
        <div class="d-flex justify-content-center align-items-center main-card">
            
            <div class="circle-card position-relative p-5 mt-5"  *ngFor="let item of profiles">
                <span class="delete-profile"><i class="fa fa-trash fs-22 text-danger" (click)="deleteProfile(item.profile.profile_id)"></i></span>
                <span class="edit-profile"> <i class="fa fa-edit fs-22"  (click)="addProfile(item.profile.profile_id)"></i></span>
                <div class="profile-img">
                    <img [src]="item.profile.profile_image || '/assets/images/girl.png'" alt="" height="200px" width="200px" (click)="loginPlaylist(item.profile)" (error)="handleImageError($event)">
                </div>
                <div class="title">
                  <h4 class="d-flex justify-content-center mt-3">
                      {{item.profile.profile_name}}
                  </h4>  
                </div>
            </div>
            <div class="circle-card  p-5 mt-5">
              <div class="profile-img">
                <img src="/assets/images/new_login_flow/add-profile.png" alt=""  height="190px" width="190px" (click)="creteProfile()">
              </div>
              <div class="title">
                <h4 class="d-flex justify-content-center mt-4">
                    Add Profile
                </h4>  
              </div>
          </div>
        </div>
      </div>
    </div>
</div>